// 2026-06-30 - FormuLearning - 관리자: 연동 API 카탈로그 목록 (REQ-FN-ADMIN-01)
// 파일 위치: frontend/src/features/admin/ApiIntegrationList.tsx

import { useEffect, useState } from 'react'
import { listIntegrations } from '../../api/admin'
import type { ApiIntegration } from '../../types/admin'

export default function ApiIntegrationList() {
  const [rows, setRows] = useState<ApiIntegration[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    listIntegrations()
      .then(setRows)
      .catch(() => setError('Failed to load integrations'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <p className="text-sm text-text-secondary">Loading…</p>
  if (error) return <p className="text-sm text-accent-purple">{error}</p>

  return (
    <div className="overflow-x-auto rounded-lg border" style={{ borderColor: 'var(--border-divider)' }}>
      <table className="w-full text-left text-sm">
        <thead className="text-xs text-text-secondary" style={{ backgroundColor: 'var(--color-bg-panel)' }}>
          <tr>
            <th className="px-3 py-2 font-medium">Code</th>
            <th className="px-3 py-2 font-medium">Name</th>
            <th className="px-3 py-2 font-medium">Provider</th>
            <th className="px-3 py-2 font-medium">Group</th>
            <th className="px-3 py-2 font-medium">Method</th>
            <th className="px-3 py-2 font-medium">Auth</th>
            <th className="px-3 py-2 font-medium">Endpoint</th>
            <th className="px-3 py-2 font-medium">Active</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t" style={{ borderColor: 'var(--border-divider)' }}>
              <td className="px-3 py-2 font-mono text-xs text-text-primary">{r.code}</td>
              <td className="px-3 py-2 text-text-body">{r.name}</td>
              <td className="px-3 py-2 text-text-body">{r.provider}</td>
              <td className="px-3 py-2 text-text-secondary">{r.grp ?? '—'}</td>
              <td className="px-3 py-2 text-text-secondary">{r.method}</td>
              <td className="px-3 py-2 text-text-secondary">{r.auth_type}</td>
              <td className="px-3 py-2 font-mono text-[11px] text-text-secondary max-w-[360px] truncate" title={r.endpoint}>{r.endpoint}</td>
              <td className="px-3 py-2">
                <span style={{ color: r.is_active ? 'var(--color-accent-teal)' : 'var(--color-text-secondary)' }}>
                  {r.is_active ? '●' : '○'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
